import { FormattedMessage, injectIntl } from 'react-intl';
import React, {
  useState,
  useContext,
  useRef,
  useEffect,
  useImperativeHandle,
} from 'react';
import { Form, Input, Button, Spin, Row, Col, Modal } from 'antd';

import _ from 'lodash';

let timeChange;
function MessageModal(props) {
  const intl = props.intl;
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <a onClick={showModal}>
        <span style={{ fontSize: '14px' }}>《银联卡支付服务协议》</span>
      </a>
      <Modal
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        maskClosable={false}
        // closable={false}
        width="90%"
        className="h5pc-message-modal"
        wrapClassName="h5pc-modal"
        destroyOnClose={true}
        // mask={false}
        forceRender
        centered
      >
        <iframe
          src="/agreement/index.html"
          style={{ height: 'calc(100vh - 40px)', border: 0, width: '100%' }}
          frameBorder="0"
        ></iframe>
      </Modal>
    </>
  );
}

export default injectIntl(MessageModal);
